import { API } from '@/modules/api-service/api-service';
import type { Core, Data } from '@strapi/types';

const url = '/customers';

export const getCustomers = async () => {
	const { data: response } = await API().get<Core.Helpers.Controllers.GetResponseBody<'api::customer.customer', 'getListOfCustomers'>>(url);

	return response;
};

export const createCustomerApi = async ({
	body,
}: {
	body: Core.Helpers.Controllers.GetRequestBody<'api::customer.customer', 'create'>;
}) => {
	return await API().post(`${url}/create`, body);
};

export const updateCustomerApi = async ({
	documentId,
	body,
}: {
	documentId: Pick<Data.Entity<'api::customer.customer'>, 'documentId'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::customer.customer', 'update'>;
}) => {
	return await API().put<
		Core.Helpers.Controllers.GetResponseBody<'api::customer.customer', 'update'>,
		Core.Helpers.Controllers.GetRequestBody<'api::customer.customer', 'update'>
	>(`${url}/update/${documentId}`, body);
};

export const deleteCustomerApi = async ({
	documentId,
}: {
	documentId: Pick<Data.Entity<'api::customer.customer'>, 'documentId'>['documentId'];
}) => {
	return await API().delete(`${url}/delete/${documentId}`);
};
